import { jsxs, jsx } from 'react/jsx-runtime';
import React__default from 'react';
import { Select } from '../Select.js';
import { states } from './states.js';

const StateSelect = React__default.forwardRef(({ countryCode, ...attrs }, ref) => (jsxs(Select, { ...attrs, ref: ref, defaultValue: attrs.defaultValue ?? "", children: [jsx("option", { value: "", disabled: true, children: "State" }), states[countryCode].map((state) => (jsx("option", { value: state.code, children: state.name }, state.code)))] }, countryCode)));
StateSelect.displayName = "StateSelect";

export { StateSelect };
//# sourceMappingURL=StateSelect.js.map
